import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=04ba87f4&scoped=true&"
import script from "./Scores.vue?vue&type=script&lang=js&"
export * from "./Scores.vue?vue&type=script&lang=js&"
import style0 from "./Scores.vue?vue&type=style&index=0&id=04ba87f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba87f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VRow,VSimpleTable})
